import { render, staticRenderFns } from "./ActivityAttribute.vue?vue&type=template&id=4b38cab7"
import script from "./ActivityAttribute.vue?vue&type=script&lang=ts"
export * from "./ActivityAttribute.vue?vue&type=script&lang=ts"
import style0 from "./ActivityAttribute.vue?vue&type=style&index=0&id=4b38cab7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports